import { render, staticRenderFns } from "./EmailSendTestModal.vue?vue&type=template&id=4874350a"
import script from "./EmailSendTestModal.vue?vue&type=script&lang=js"
export * from "./EmailSendTestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports